import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect, useRef, useState } from 'react';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Input from '@mui/material/Input';
import { ArrowDropDown } from '@mui/icons-material';
import { InputAdornment, IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';
//import { useFileRepository } from '../../FileRepository/FileRepositoryContext';

interface DialogBoxFolderProps {
    openDialogBox: boolean;
    dialogTitle?: string;
    dialogBody?: string;
    dialogAction?: string;
    dialogActionCancel?: string;
    handleFunction?: (file: File[]) => void;
    handleCancel?: () => void;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogBoxFormIRPTest: React.FC<DialogBoxFolderProps> = (props) => {
    const [open, setOpen] = useState(false);
    //const { folderList } = useFileRepository()
    const [dialogTitle, setDialogTitle] = useState<string>("");
    const [dialogAction, setDialogAction] = useState<string>("");
    const [dialogActionCancel, setDialogActionCancel] = useState<string>("");
    const [selectedFile, setSelectedFile] = useState<File[]>([]);
    const fileInputRef = useRef<HTMLInputElement | null>(null);


    useEffect(() => {
        setOpen(props.openDialogBox);
        setDialogTitle(props.dialogTitle || "");
        setDialogAction(props.dialogAction || "");
        setDialogActionCancel(props.dialogActionCancel || "");
    }, [props.openDialogBox, props.dialogTitle, props.dialogAction, props.dialogActionCancel]);

    const handleClose = () => {
        if (props.handleCancel) {
            props.handleCancel();
        }
        setSelectedFile([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Clear the input field
        }
    };

    const handleOk = () => {
        // if (folderList?.some((folder: FolderList) => folderName.toLocaleLowerCase() === folder.folderName?.toLocaleLowerCase())) {
        //     setFolderNameError("This folder name already exists.");
        //     return;
        // }
        if (props.handleFunction) {
            if (selectedFile.length > 0) {
                props.handleFunction(selectedFile);
            }
        }
        handleClose();
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        handleOk();
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            // console.log("handleFileChange", event.target.files[0]);
            const files = Array.from(event.target.files)
            setSelectedFile(files)
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            TransitionComponent={Transition}
            keepMounted
            PaperProps={{
                component: 'form',
                onSubmit: handleFormSubmit,
            }}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle id="alert-dialog-title">
                {dialogTitle}
            </DialogTitle>
            <DialogContent>
                <div>
                    < Input
                        type="file"
                        inputRef={fileInputRef}
                        inputProps={{ accept: '*/*', multiple: true }}
                        onChange={handleFileChange}
                        required
                        fullWidth
                        margin="dense"
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton edge="end">
                                    <ArrowDropDown />
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                    {selectedFile.length > 1 && (
                        <Typography variant="body2" margin="dense">
                            Selected files:
                            <List>
                                {selectedFile.map((file, index) => (
                                    <ListItem key={index}>
                                        <ListItemText primary={file.name} />
                                    </ListItem>
                                ))}
                            </List>
                        </Typography>
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant="contained" onClick={handleClose} sx={{
                    backgroundColor: "rgba(0, 102, 255, 0.1)",
                    color: "#0066FF",
                    '&:hover': {
                        bgcolor: "#0066ff2e",
                    },
                }}>
                    {dialogActionCancel}
                </Button>
                <Button size='small' variant='contained' type="submit" sx={{
                    backgroundColor: "#0066FF",
                    '&:hover': {
                        bgcolor: "#0556d0",
                    },
                }}>{dialogAction}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogBoxFormIRPTest;
